// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"634":"66c0fc31","977":"23cf4058"}[chunkId] + ".chunk.js");